<div class="table-scroll-wrapper">
  <table class="custom-table">
    <thead>
      <tr>
        <th class="region-header"></th>
        <ng-container *ngFor="let cat of categories">
          <th class="region-header" [attr.colspan]="subHeaders.length">{{ cat.title }}</th>
        </ng-container>
      </tr>
      <tr>
        <th class="sub-header">{{ mainHeader }}</th>
        <ng-container *ngFor="let cat of categories">
          <th *ngFor="let sub of subHeaders" class="sub-header">{{ sub }}</th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rowLabels">
        <td class="row-label">{{ row }}</td>
        <ng-container *ngFor="let cat of categories">
          <td *ngFor="let sub of subHeaders" class="data-cell">
            <div class="value">{{ cat.data[row][sub].value }}</div>
            <div class="percentage">({{ cat.data[row][sub].percentage }})</div>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>